// src/utils/gameNames.js
// Shared utility for game name mapping across dashboard components

export const getGameNames = () => {
  return {
    // Original session names
    'arabicNumberSpeed': 'Raqam Rush',
    'arabicNumberFishing': 'Number Fishing',
    'arabicNumberMatching': 'Flip & Find', 
    'arabicNumberSumTarget': 'Number Hunt', 
    'ArabicNumberSequencingGame': 'Sequence Master', 
    'lettersoundmatchgame': 'Letter Sounds',
    'alphabetTracing': 'Trace Quest',
    'arabicHangman': 'Arabic Hangman', 
    'WordMatchGameV2': 'Match & Learn', 
    'arabicMemoryCards': 'Memory Mirage', 
    'AudioQuizGame': 'Sonic Safari', 
    'arabicFlagGuesser': 'Flag Explorer', 
    'biggerSmallerCountries': 'Pop Quest',
    'mapExplorer': 'Map Explorer',
    'chat': 'Camly AI Tutor',
    
    // Additional progress data names (different naming convention)
    'arabicNumberSpeedGame': 'Raqam Rush',
    'ArabicNumberCardMatchingGame': 'Flip & Find',
    'wordMatchGame': 'Match & Learn',
    'letterSoundMatch': 'Letter Sounds'
  };
};

export const getGameName = (gameType) => {
  const gameNames = getGameNames();
  return gameNames[gameType] || gameType;
};

export const getGameIcon = (gameType) => {
  const iconMap = {
    'mapExplorer': '🗺️',
    'arabicNumberFishing': '🎣',
    // Original session names
    'arabicNumberSpeed': '🔢',
    'arabicNumberMatching': '🎯',
    'arabicNumberSumTarget': '🎲',
    'ArabicNumberSequencingGame': '📊',
    'lettersoundmatchgame': '🔤',
    'letterSoundMatch': '🔤',
    'alphabetTracing': '✍️',
    'arabicHangman': '🎭',
    'WordMatchGameV2': '🧩',
    'arabicMemoryCards': '🃏',
    'AudioQuizGame': '🎵',
    'arabicFlagGuesser': '🏳️',
    'biggerSmallerCountries': '🌍',
    'chat': '🤖',
    
    // Additional progress data names (different naming convention)
    'arabicNumberSpeedGame': '🔢',
    'ArabicNumberCardMatchingGame': '🎯',
    'wordMatchGame': '🧩'
  };
  return iconMap[gameType] || '🎮';
};